module.exports = __webpack_public_path__ + "static/media/vinny_caravano.be55d00e.jpg";